<div mat-dialog-content role="dialog" aria-modal="true" aria-labelledby="tf-cert-modal-title" aria-describedby="tf-cert-modal-description">
  <div class="dialog-header">
    <div class="header-icon-wrapper">
      <img src="assets/icons/shield-icon.svg" alt="Icono de escudo" class="header-icon-img" />
    </div>
    <h3 id="tf-cert-modal-title" tabindex="-1" cdkFocusInitial>Certifirma Digital Físico – Seleccionar certificado</h3>
    <p id="tf-cert-modal-description" class="sr-only">Elija el certificado con el que desea firmar los documentos</p>
  </div>

  <div class="tf-cert-content">
  <p class="label-document">Seleccione un certificado para firmar</p>
  <div class="certificate-list">
    <div
      class="certificate-item"
      *ngFor="let cert of data.certificates"
      (click)="selectCertificate(cert)"
      [class.selected]="selectedCertificate === cert"
      role="button"
      tabindex="0"
      [attr.aria-label]="'Certificado: ' + displayName(cert)"
      [attr.aria-pressed]="selectedCertificate === cert"
      (keydown.enter)="selectCertificate(cert)"
      (keydown.space)="selectCertificate(cert); $event.preventDefault()">
      <img
        *ngIf="selectedCertificate !== cert"
        src="assets/icons/certificate-icon-unselected.svg"
        alt="Icono de certificado digital"
        class="certificate-logo" />
      <img
        *ngIf="selectedCertificate === cert"
        src="assets/icons/certificate-icon-selected.svg"
        alt="Icono de certificado digital seleccionado"
        class="certificate-logo" />
      <div class="certificate-info">
        <div class="certificate-title-row">
          <p class="certificate-title">{{ displayName(cert) }}</p>
          <span *ngIf="getCertificateType(cert)" 
                class="certificate-badge" 
                [ngClass]="getCertificateType(cert)?.cssClass">
            {{ getCertificateType(cert)?.label }}
          </span>
        </div>
        <p class="cert-issuer" *ngIf="cert.issuerDN">
          <i class="fas fa-building"></i> {{ extractIssuerName(cert.issuerDN) }}
        </p>
        <div class="certificate-details">
          <span class="cert-detail" *ngIf="cert.serialNumber">
            <i class="fas fa-hashtag"></i> {{ formatSerial(cert.serialNumber) }}
          </span>
          <span class="cert-detail" *ngIf="cert.keyAlgorithm">
            <i class="fas fa-key"></i> {{ cert.keyAlgorithm }}
          </span>
        </div>
        <div class="certificate-dates">
          <span class="cert-detail" *ngIf="cert.notBefore">
            <i class="fas fa-calendar-plus"></i> Desde: {{ formatDate(cert.notBefore) }}
          </span>
          <span class="cert-detail" *ngIf="cert.notAfter">
            <i class="fas fa-calendar-times"></i> Hasta: {{ formatDate(cert.notAfter) }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="button-container">
    <button
      class="btn btn-secondary"
      (click)="closeDialog()"
      type="button"
      aria-label="Cancelar y cerrar">
      Cancelar
    </button>
    <button
      class="btn btn-primary"
      (click)="confirmSelection()"
      [disabled]="!selectedCertificate"
      type="button"
      [attr.aria-label]="selectedCertificate ? 'Firmar con certificado seleccionado' : 'Seleccione un certificado'"
      [attr.aria-disabled]="!selectedCertificate">
      Firmar documentos
    </button>
  </div>
  </div>
</div>
